import React from 'react';
import { func, string } from 'prop-types';
import { Field, Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import { intlShape, injectIntl } from '../../../util/reactIntl';
import { Button, FieldLocationAutocompleteInput, FieldTextInput, Form } from '../../../components';

import css from '../SearchPage.module.css';
import IconSearchDesktop from '../../NotFoundPage/SearchForm/IconSearchDesktop';
import { SEARCH_TYPE_OPTIONS } from '../../../config/configSearch';
import { SearchType } from '../../../util/enums';
import { isMobileViewport } from '../../../util/viewport';

const identity = v => v;

const SectionFilterFormComponent = props => {
  const { viewport } = props;
  return (
    <FinalForm
      {...props}
      render={formRenderProps => {
        const {
          rootClassName,
          className,
          values,
          intl,
          isSearchPageFilter,
          handleSubmit,
          form,
        } = formRenderProps;
        const { searchType } = values || {};

        const classes = classNames(rootClassName || css.root, className, {
          [css.searchPageFilter]: isSearchPageFilter,
        });

        const handlePlaceSelect = place => {
          form.change('location', {
            search: place.address || place.description,
            selectedPlace: place,
          });
          form.submit();
        };

        const isMobileLayout = isMobileViewport(viewport);
        return (
          <Form className={classes} onSubmit={handleSubmit}>
            <Field name="searchType" component="select" className={css.searchTypeSelector}>
              {SEARCH_TYPE_OPTIONS.map(({ value, messageId }) => (
                <option key={value} value={value}>
                  {intl.formatMessage({ id: messageId })}
                </option>
              ))}
            </Field>
            {searchType === SearchType.LOCATION && (
              <FieldLocationAutocompleteInput
                rootClassName={css.locationAddress}
                inputClassName={css.locationAutocompleteInput}
                iconClassName={css.locationAutocompleteInputIcon}
                predictionsClassName={css.predictionsRoot}
                validClassName={css.validLocation}
                name="location"
                label=""
                placeholder={intl.formatMessage({
                  id: 'SectionFilterForm.locationPlaceholder',
                })}
                useDefaultPredictions={true}
                format={identity}
                valueFromForm={values.location}
                isSearchPageFilter={isSearchPageFilter}
                onChange={value => {
                  form.change('location', value);
                }}
                onPlaceSelected={handlePlaceSelect}
              />
            )}
            {searchType === SearchType.KEYWORDS && (
              <FieldTextInput
                type="text"
                className={css.keywordsInput}
                id="keywords"
                name="keywords"
                placeholder={intl.formatMessage({
                  id: 'LandingSearchForm.keywordsPlaceholder',
                })}
              />
            )}
            <Button
              className={classNames({
                [css.searchIcon]: isSearchPageFilter,
                [css.searchBtn]: !isSearchPageFilter,
              })}
              type="submit"
            >
              <IconSearchDesktop /> {isMobileLayout || isSearchPageFilter ? '' : 'Search'}
            </Button>
          </Form>
        );
      }}
    />
  );
};

SectionFilterFormComponent.defaultProps = { rootClassName: null, className: null };

SectionFilterFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  onSubmit: func.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const SectionFilterForm = injectIntl(SectionFilterFormComponent);

export default SectionFilterForm;
